import { render, staticRenderFns } from "./MissingLocaleGrid.vue?vue&type=template&id=14629fbe&scoped=true&"
import script from "./MissingLocaleGrid.vue?vue&type=script&lang=js&"
export * from "./MissingLocaleGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14629fbe",
  null
  
)

export default component.exports